"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegistrationTokenAthleteDto = /** @class */ (function () {
    function RegistrationTokenAthleteDto() {
    }
    return RegistrationTokenAthleteDto;
}());
exports.default = RegistrationTokenAthleteDto;
